import React from 'react';
import styled from 'styled-components';
import images from '../../Theming/images';

const Logo = styled.img``;

const ItvLogo: React.FC<React.CSSProperties> = ({ ...rest }) => {
  return (
    <Logo
      id="itv-logo"
      src={images.Itv_logo.default}
      alt="Itv logo"
      style={{ ...rest }}
    />
  );
};

ItvLogo.defaultProps = {
  height: 15,
};
export default ItvLogo;
